export default __webpack_public_path__ + "static/media/group-13.3cf48abf.svg";